import { connect } from 'react-redux'
import ReportView from '../components/ReportsView'
import {changeReportType, loadReports, generateReport, changeActiveHistoryPage,
  changeReportMode, changeFilterDates, resetFilterDates, switchAutomaticReport,
  changeDayOfWeekOnAutomaticReport, addAutomaticEmail, removeAutomaticEmail, changeEmailInput,
  loadAutomaticReportConfig, updateAutomaticReportConfig} from '../modules/reports'
import {printReceipt} from "../../ShoppingCart/modules/shoppingCart";
import moment from "moment";
import {USER_ROLES} from "../../../constants";

const mapDispatchToProps = {
  changeReportType,
  loadReports,
  generateReport,
  printReceipt,
  changeActiveHistoryPage,
  changeReportMode,
  changeFilterDates,
  resetFilterDates,
  switchAutomaticReport,
  changeDayOfWeekOnAutomaticReport,
  addAutomaticEmail,
  removeAutomaticEmail,
  changeEmailInput,
  loadAutomaticReportConfig,
  updateAutomaticReportConfig
};

const mapStateToProps = (state) => {

  const activePage = state.reports.history_active_page;
  const itemsPerPage = 5;
  const totalPages = Math.ceil((state.reports.list ? state.reports.list.length : 0) / itemsPerPage);

  return {
    mode: state.reports.mode,
    type: state.reports.type,
    reports: state.reports.list && state.reports.list.slice((itemsPerPage * (activePage - 1)), itemsPerPage * activePage),
    loading: state.reports.loading,
    history_active_page: activePage,
    total_pages: totalPages,
    filter_start_date: state.reports.filter_start_date ? moment(state.reports.filter_start_date) : null,
    filter_end_date: state.reports.filter_end_date ? moment(state.reports.filter_end_date) : null,
    automatic_daily_enabled: state.reports.automatic_daily_enabled,
    automatic_days: state.reports.automatic_days,
    automatic_email_input: state.reports.automatic_email_input,
    automatic_emails: state.reports.automatic_emails,
    hide_days_of_week: !state.reports.automatic_daily_enabled,
    configure_devices: state.user.role === USER_ROLES.STORE_OWNER
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportView)


// WEBPACK FOOTER //
// ./src/components/Reports/containers/ReportsViewContainer.js